import {
  TrialPeriodUnit,
  BillingCyclesUnit,
  BillingPeriodUnit
} from '../../common/contracts';

export enum BillingCyclesEnum {
  FIXED = 'Fixed'
}

export enum BillingFrequencyEnum {
  DAILY = 'Daily',
  WEEKLY = 'Weekly',
  MONTHLY = 'Monthly',
  YEARLY = 'Yearly'
}

export enum TrialPeriodUnitEnum {
  DAYS = 'Days',
  MONTHS = 'Months'
}

export const TRIAL_PERIOD_UNIT_OPTIONS = [
  {
    label: TrialPeriodUnit.DAYS,
    value: TrialPeriodUnit.DAYS
  },
  {
    label: TrialPeriodUnit.MONTHS,
    value: TrialPeriodUnit.MONTHS
  }
];

export const BILLING_PERIOD_UNIT_OPTIONS = [
  {
    label: BillingPeriodUnit.DAILY,
    value: BillingPeriodUnit.DAILY
  },
  {
    label: BillingPeriodUnit.WEEKLY,
    value: BillingPeriodUnit.WEEKLY
  },
  {
    label: BillingPeriodUnit.MONTHLY,
    value: BillingPeriodUnit.MONTHLY
  },
  {
    label: BillingPeriodUnit.YEARLY,
    value: BillingPeriodUnit.YEARLY
  }
];

export const BILLING_CYCLES_UNIT_OPTIONS = [
  {
    label: BillingCyclesUnit.FIXED,
    value: BillingCyclesUnit.FIXED
  },
  {
    label: BillingCyclesUnit.FOREVER,
    value: BillingCyclesUnit.FOREVER
  }
];
